import type { HttpClient } from '../http/HttpClient'
import type { WeekSchedule, WeekScheduleRepository } from '@/domain/home/WeekSchedule'

export class HttpWeekScheduleRepository implements WeekScheduleRepository {
  constructor(private readonly http: HttpClient) {}

  startingOn(start: string): Promise<WeekSchedule> {
    return this.http.url('purchases/week-schedule').params({ start }).get<WeekSchedule>()
  }
}
